// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18zrpxbi{padding-inline:var(--ds-space-200,1pc)}\n._1rjcu2gc{padding-block:var(--ds-space-100,8px)}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._1o9zidpf{flex-shrink:0}\n._2hwxutpp{margin-right:var(--ds-space-150,9pt)}\n._4cvr1h6o{align-items:center}\n._k48pi7a9{font-weight:var(--ds-font-weight-regular,400)}", ""]);
// Exports
module.exports = exports;
